import { useState } from 'react'

import { Tab } from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useLoading, useModal } from 'hooks'
import useToggle from 'hooks/useToggle'
import { SyndicateServices } from 'services/NGT/Syndicate'
import { FORMAT } from 'utils'

import { SyndicateForm, SearchSyndicate } from './components'

export default function Syndicate() {
  const tabs = ['Pesquisar', 'Adicionar Novo']
  const [selectedTab, setSelectedTab] = useState(0)

  const { loading, msgErro, setLoading, setMsgErro } = useLoading()
  const [isModalOpen, toggleModal] = useToggle()

  const { showModal } = useModal()

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  const handleAddNewSyndicate = async (data: any) => {
    setLoading('loading')

    const syndicateData = {
      ...data,
      cdCnpj: FORMAT.unMask(data.cdCnpj)
    }

    SyndicateServices()
      .create(syndicateData)
      .then(() => {
        setLoading('idle')
        toggleModal()
      })
      .catch((err) => {
        // setLoading('error')
        // setMsgErro(
        //   err?.response?.data?.title
        //     ?.replace('Cnpj', 'CNPJ')
        //     .replace('Inválido', 'inválido!') ||
        //   'Não foi possivel cadastrar este sindicato.'
        // )
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: err?.response?.data?.title
            ?.replace('Cnpj', 'CNPJ')
            .replace('Inválido', 'inválido!') ||
            'Não foi possivel cadastrar este sindicato.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 ? (
        <SearchSyndicate />
      ) : (
        <>
          <SyndicateForm
            handleAddNewSyndicate={handleAddNewSyndicate}
            msgError={msgErro}
            loading={loading}
            isModalOpen={isModalOpen}
            setLoading={setLoading}
            toggleModal={toggleModal}
          />
          <SuccessModal
            open={loading === 'error'}
            message={msgErro}
            type="error"
            hideButtonCancel
            handleConfirm={() => setLoading('idle')}
            txtButtonConfirm="Voltar"
          />
          <SuccessModal
            open={isModalOpen}
            message="Dados incluídos com sucesso!"
            type="sucess"
            hideButtonCancel
            txtButtonConfirm="OK"
            handleConfirm={() => {
              toggleModal()
              setSelectedTab(0)
            }}
          />
        </>
      )}
    </>
  )
}
